export enum Pages {
    PROJEKTLISTE,
    ARCHIVLISTE,
    PROJEKTDETAILS
} 
  